/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rosy_Deep_Heron_MeltInputs */

const en_rosy_deep_heron_melt = /** @type {(inputs: Rosy_Deep_Heron_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All labels`)
};

const de_rosy_deep_heron_melt = /** @type {(inputs: Rosy_Deep_Heron_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Labels`)
};

/**
* | output |
* | --- |
* | "All labels" |
*
* @param {Rosy_Deep_Heron_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rosy_deep_heron_melt = /** @type {((inputs?: Rosy_Deep_Heron_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rosy_Deep_Heron_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rosy_deep_heron_melt(inputs)
	return de_rosy_deep_heron_melt(inputs)
});